import { Box, MenuItem, Modal, TextField } from '@mui/material';
import React, { useState } from 'react'
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import Swal from 'sweetalert2';
import request from '../../../../Helpers/API';
import { GetDocumentoCSV } from '../../../../Helpers/GetDocumentoCSV';

export const CargaMasiva = ({ open, onClose, preciosGarantia, onExecute }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [infoGarantia, setInfoGarantia] = useState({
        tipo_carga: "AD",
        inicio_vigencia: "",
        vigencia: ""
    });

    const [infoCSV, setInfoCSV] = useState(null);

    const [documento, setDocumento] = useState({
        documento: "",
        extension: "",
    });


    const guardarModelo = () => {


        if (infoGarantia.inicio_vigencia === '' || infoGarantia.inicio_vigencia === null || infoGarantia.inicio_vigencia === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe ingresar una inicio para la promoción",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (infoGarantia.vigencia === '' || infoGarantia.vigencia === null || infoGarantia.vigencia === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe ingresar una vigencia para el precio ajustado",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        const fechaInicio = new Date(infoGarantia.inicio_vigencia);
        const fechaVigencia = new Date(infoGarantia.vigencia);

        if (fechaVigencia < fechaInicio) {
            Swal.fire({
                title: "GARANTIAS",
                text: "La fecha de vigencia debe ser mayor o igual al inicio de vigencia",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            tipo_carga: infoGarantia.tipo_carga,
            inicio_vigencia: infoGarantia.inicio_vigencia,
            vigencia: infoGarantia.vigencia,
            datos: infoCSV === null ? preciosGarantia : infoCSV
        }
        request
            .post(`DashboardPostventa/CargarPreciosGarantias`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                onExecute()
                await Swal.fire({
                    title: "GARANTIAS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setInfoGarantia({
                    ...infoGarantia,
                    tipo_carga: "AD",
                    inicio_vigencia: "",
                    vigencia: ""
                });
                setInfoCSV(null)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("GARANTIAS", JSON.stringify(error), "error");
            });
    };

    const onDescargarCSV = () => {
        // setLoader({ ...loader, mostrar: true });

        // 1. Obtener encabezados (keys del primer objeto)
        const headers = Object.keys(preciosGarantia[0]).join(",");

        // 2. Mapear las filas (values de cada objeto)
        const rows = preciosGarantia.map(obj => Object.values(obj).join(","));

        // 3. Unir todo en formato CSV
        const csv = [headers, ...rows].join("\n");

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "Precios Garantias.csv");
        link.click();
    };

    const handleDateChange = (e) => {
        setInfoGarantia({ ...infoGarantia, vigencia: e.target.value });
    };

    const handleDateInicioChange = (e) => {
        setInfoGarantia({ ...infoGarantia, inicio_vigencia: e.target.value });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file && file.type === 'text/csv') {
            const reader = new FileReader();

            reader.onload = (e) => {
                const contenido = e.target.result;

                // Dividir líneas, filtrando vacías
                const lines = contenido.split('\n').filter(line => line.trim() !== '');
                if (lines.length < 2) {
                    alert('El archivo CSV no tiene suficientes filas.');
                    return;
                }

                // Tomar encabezados desde la primera fila
                const headers = lines[0].split(',').map(h => h.trim());

                // Convertir las filas siguientes en objetos
                const data = lines.slice(1).map(line => {
                    const values = line.split(',').map(value => value.trim());
                    const rowObj = {};
                    headers.forEach((header, index) => {
                        rowObj[header] = values[index] ?? '';
                    });
                    return rowObj;
                });

                setInfoCSV(data);
            };

            reader.readAsText(file);
        } else {
            alert('Por favor, selecciona un archivo CSV válido.');
        }
    };

    console.log(infoCSV)
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="modelos-modal-formulario">
                    <div className="modelos-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"Carga de CSV"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`modelos-modal-agregar-convenio`}>
                                    <div className="modelos-modal-agregar-convenio-container">
                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Tipo de Carga"
                                                variant="outlined"
                                                className="cel-1"
                                                select
                                                type="text"
                                                onChange={({ target }) => {
                                                    setInfoGarantia({
                                                        ...infoGarantia,

                                                        tipo_carga: target.value,
                                                    });
                                                }}
                                                value={infoGarantia.tipo_carga}
                                            >
                                                <MenuItem value={"AD"}>Actualizar Datos</MenuItem>
                                                <MenuItem value={"CN"}>Carga Nueva</MenuItem>
                                            </TextField>

                                            <button
                                                className='carga-masiva-descargar-plantilla'
                                                onClick={() => onDescargarCSV()}
                                            >
                                                Descargar Plantilla
                                            </button>
                                        </Box>

                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                fullWidth
                                                type="file"
                                                // onChange={({ target }) => GetDocumentoCSV(target, setDocumento)}
                                                onChange={handleFileChange}
                                                sx={{ mt: 2 }}
                                            />
                                        </Box>

                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                id="vigencia"
                                                label="Inicio de promoción"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.inicio_vigencia}
                                                onChange={handleDateInicioChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />
                                            <TextField
                                                id="vigencia"
                                                label="Vigencia"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.vigencia}
                                                onChange={handleDateChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />

                                        </Box>
                                    </div>
                                    <div className="modelos-modal-buttons">
                                        <button
                                            className="modelos-modal-button-guardar"
                                            onClick={() => guardarModelo()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
}
